/*
 * PBK About Motion — footer 上のロゴモーション（背景固定バンド）
 * 仕様(Figma 仕様コメント 4309:115060 / 2026-07-28): mp4 をループ再生・背景固定でレイヤー感。
 * 位置・トリミング・固定は CSS 側（.pbk-about-motion / __media）。この JS の担当は 3 点だけ:
 *   1. ループ再生の停止/再開ボタン（WCAG 2.2.2 Pause,Stop,Hide）
 *   2. reduced-motion では自動再生せず src も外して取得を止める（ボタンで任意再生）
 *   3. 画面外では pause（ループ動画を裏で回し続けない）+ ハーネス撮影(data-static)では停止
 */
(function () {
  'use strict';

  function setup(section) {
    var video = section.querySelector('.pbk-about-motion__video');
    var toggle = section.querySelector('[data-about-motion-toggle]');
    if (!video) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isStatic =
      document.documentElement.hasAttribute('data-static') || document.body.hasAttribute('data-static');
    var userPaused = false;

    function setState(state) {
      if (!toggle) return;
      toggle.dataset.state = state;
      toggle.setAttribute('aria-label', state === 'playing' ? 'ロゴモーションを一時停止' : 'ロゴモーションを再生');
    }

    // reduced-motion 時の src 退避 / 復帰（<source> は video_tag だと複数ありうる）
    function sources() {
      return video.querySelectorAll('source');
    }
    function detachSrc() {
      var list = sources();
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('src')) {
          list[i].dataset.src = list[i].getAttribute('src');
          list[i].removeAttribute('src');
        }
      }
      if (video.getAttribute('src')) {
        video.dataset.src = video.getAttribute('src');
        video.removeAttribute('src');
      }
      video.load(); // 進行中の取得を打ち切る
    }
    function attachSrc() {
      var restored = false;
      var list = sources();
      for (var i = 0; i < list.length; i++) {
        if (list[i].dataset.src) {
          list[i].setAttribute('src', list[i].dataset.src);
          delete list[i].dataset.src;
          restored = true;
        }
      }
      if (video.dataset.src) {
        video.setAttribute('src', video.dataset.src);
        delete video.dataset.src;
        restored = true;
      }
      if (restored) video.load();
      return restored;
    }

    function play() {
      var p = video.play && video.play();
      if (p && p.catch) p.catch(function () {});
    }

    video.addEventListener('play', function () { setState('playing'); });
    video.addEventListener('pause', function () { setState('paused'); });

    if (toggle) {
      toggle.hidden = false; // JS 無効時は死んだボタンを出さない
      toggle.addEventListener('click', function () {
        if (!video.paused) {
          userPaused = true;
          video.pause();
          return;
        }
        userPaused = false;
        attachSrc();
        play();
      });
    }

    if (reduce || isStatic) {
      video.pause();
      video.removeAttribute('autoplay');
      video.removeAttribute('loop');
      if (reduce) detachSrc();
      setState('paused');
      return;
    }

    setState('playing');
    play();

    // 画面外ではループを止める（ユーザーが止めた場合はそのまま）
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              if (!userPaused && video.paused) play();
            } else if (!video.paused) {
              video.pause();
            }
          }
        },
        { rootMargin: '100px' }
      ).observe(section);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (!video.paused) video.pause();
      } else if (!userPaused && video.paused) {
        play();
      }
    });
  }

  function init() {
    document.querySelectorAll('.pbk-about-motion').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // テーマエディタでの section 追加/再読込
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector && e.target.querySelector('.pbk-about-motion');
    if (s) setup(s);
  });
})();
